import {ICarouselProps, IThumbsProps} from './ICarousel';
import { defaultStatusFormatter} from './utils';
import Tlass from './cssClasses';
import React from 'react';
import {ReoIcon} from '@reolink-web/ui';
import './carousel.css';
import { slideStopSwipingHandler, slideSwipeAnimationHandler } from './animations';
import classNames from 'classnames';
import CONFIG from '@/config';

export const defaultProps: ICarouselProps = {
    axis: 'horizontal',
    centerSlidePercentage: 80,
    centerSlidePadding: 0,
    autoPlay: true,
    slideToChange: 1,
    isHoverArrow: true,
    interval: 3000,
    leftMode: false,
    labels: {
        leftArrow: 'revious slide / item',
        rightArrow: 'next slide / item',
        item: 'slide item'
    },
    thumbWidth: 80,
    preventMovementUntilSwipeScrollTolerance: false,
    renderArrowPrev: (onClickHandler: () => void, hasPrev: boolean, label: string): React.ReactElement =>  {
        return  <div className={Tlass.arrowPrev(!hasPrev)}  role="button" aria-label={label} onClick={onClickHandler}  ><ReoIcon name={'icon-icon_arrow-left'} color='#ffffff' width={CONFIG.screen === 'mobile'?12:22} className='arrow-icon' ></ReoIcon></div>;
    },
    renderArrowNext: (onClickHandler: () => void, hasNext: boolean, label: string): React.ReactElement => {
        return  <div className={Tlass.arrowNext(!hasNext)}  role="button" aria-label={label} onClick={onClickHandler}  ><ReoIcon name='icon-icon_arrow-right' color='#ffffff' width={CONFIG.screen === 'mobile'?12:22} className='arrow-icon'></ReoIcon></div>;
    },
    renderIndicator: (
        onClickHandler: (e: React.MouseEvent | React.KeyboardEvent) => void,
        isSelected: boolean,
        index: number,
        label: string,
        isPreSelected: boolean,
        isSpecial: boolean
    ) => {
        return (
            <li
                className={classNames(Tlass.dot(isSelected), isSelected&& !isSpecial? Tlass.dotAimation(isPreSelected):'')}
                onClick={onClickHandler}
                onKeyDown={onClickHandler}
                value={index}
                key={index}
                role='button'
                tabIndex={0}
                aria-label={`${label} ${index + 1}`}
            />
        );
    },
    renderItem: (item: React.ReactNode) => {
        return item;
    },
    renderThumbs: (children: React.ReactChild[]) => {
        const images = React.Children.map<React.ReactChild | undefined, React.ReactChild>(children, (item) => {
            let img: React.ReactChild | undefined = item;
            if((item as React.ReactElement<{ children: React.ReactChild[];}>).type !== 'img') {

                img = (React.Children.toArray((item as React.ReactElement).props.children) as React.ReactChild[]).find(
                    (children) => (children as React.ReactElement).type === 'img'
                );
            }
            if(!img) {
                return undefined;
            }

            return img;
        });

        if (images.filter((image) => image).length === 0) {
            console.warn(
                'No images found! Can\'t build the thumb list without images. If you don\'t need thumbs, set showThumbs={false} in the Carousel.'
            );
            return [];
        }

        return images;
    },
    statusFormatter: defaultStatusFormatter,
    selectedItem: 0,
    showArrows: true,
    showIndicators: true,
    showStatus: false,
    showThumbs: false,
    stopOnHover: true,
    infiniteLoop: true,
    swipeScrollTolerance: 5,
    swipeable: true,
    transitionTime: 600,
    veriticalSwipe: 'standard',
    width: '100%',
    animationHandler: 'slide', //fade
    swipeAnimationHandler: slideSwipeAnimationHandler,
    stopSwipingHandler: slideStopSwipingHandler,
    emulateTouch: true,

};

export const defaultThumbsProps: IThumbsProps = {
    axis: 'horizontal',
    labels: {
        leftArrow: 'previous slide / item',
        rightArrow: 'next slide / item',
        item: 'slide item'
    },
    selectedItem: 0,
    thumbWidth: 80,
    transitionTime: 500,
};
